import ONavbar from "@/components/organisms/ONavbar";
import OInputForm from "@/components/organisms/OInputForm";
export default {
  name: "p-home",
  components: {
    ONavbar,
    OInputForm
  },
  props: {
    theme: {
      type: String,
      default() {
        return "light";
      }
    }
  },
  computed: {
    compTheme() {
      if (this.theme === "light") {
        return ["bg-light", "text-dark"].join(" ");
      } else {
        return ["bg-dark", "text-light"].join(" ");
      }
    }
  }
};